<!--
  Vue wrapper for Bryntum BryntumFullscreenButton
-->

<template>
    <div />
</template>

<script>

import { Fullscreen } from '@bryntum/scheduler';
import WrapperHelper from './WrapperHelper.js';

export default {

    name : 'BryntumFullscreenButton',

    mounted() {
        const { createFullscreenButton } = WrapperHelper();
        this.button = createFullscreenButton(this.$el);
    },

    beforeDestroy() {
        if (this.button) {
            Fullscreen.onFullscreenChange(null);
            this.button.destroy();
        }
    }

};
</script>
